/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';

@Component({
    selector: 'app-delete-pop-up',
    templateUrl: './delete-pop-up.component.html',
    styleUrls: ['./delete-pop-up.component.scss'],
    standalone: false
})
export class DeletePopUpComponent {
  deleteValueForm: FormGroup;
  title = 'Confirm Delete';
  valueToDelete: string;

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<DeletePopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title || !data.valueToDelete) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.valueToDelete = data.valueToDelete;
    }

    this.deleteValueForm = new FormGroup({
      deleteValue: new FormControl(this.deleteValueForm, [Validators.required])
    });
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return boolean to delete it from DB.
   */
  deleteValue(): void {
    this.dialogRef.close({
      data: {
        deleteValue: true
      }
    });
  }

}



